import { ApiEndPoint } from './apiEndPoint'

export const getTranslations = new ApiEndPoint('translation/{language}')
export const getTranslation = new ApiEndPoint('translation/{language}/{key}')
export const getTranslationKeys = new ApiEndPoint('translation/keys')
export const getLanguages = new ApiEndPoint('translation/languages')